import { render, staticRenderFns } from "./IntegrationForm.vue?vue&type=template&id=3dd3706a&scoped=true&"
import script from "./IntegrationForm.vue?vue&type=script&lang=js&"
export * from "./IntegrationForm.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationForm.vue?vue&type=style&index=0&id=3dd3706a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd3706a",
  null
  
)

export default component.exports